import React, { useState ,useEffect} from 'react';
import { useNavigate } from "react-router-dom"
import './home.css';
import { HomeBanner } from '../../component/banner'
import SideBar from './component/sidebar'
import DashBoard from './component/dasboard'
import OrderList from '../orders/orderList'
import firebase from 'firebase/compat/app';

const Home = () => {
  const navigate = useNavigate();
  const [selectedPage, setSelectedPage] = useState('dashboard');
  const [selectedPageData, setSelectedPageData] = useState('dashboard');
  const [user,setUser]=useState()
  
  useEffect(()=>{
    firebase?.auth()?.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        var uid = user.uid;
        console.log('currentUserDe',user)
        setUser(user)
        fetchCustomClaims()
        // 👈 Your code that needs an active user goes here
      } else {
        // User is signed out
        // ...
        navigate("/")

      }
    });

  },[])

  const fetchCustomClaims=()=>{
    firebase.auth().currentUser.getIdTokenResult()
    .then((user) => {
      setUser(user)
  })
  .catch((error) => {
    console.log(error);
  });
  }
  
 

  const handlePageSelect=(page,data)=>{
    setSelectedPage(page)
    setSelectedPageData(data)
  }

  const LoadPageBySelection = () => {
    switch (selectedPage) {
      case 'dashboard':
        return <DashBoard handlePageSelect={handlePageSelect} user={user}/>
             case 'orders':
          return <OrderList handlePageSelect={handlePageSelect} user={user}/>
       
    }
  }

  return (
    <>
      <HomeBanner user={user} />
      <SideBar onSelect={handlePageSelect} selectedPage={selectedPage} user={user}/>
      <div className='main_container'>
        <LoadPageBySelection />
      </div>
    </>
  )
};

export default Home;